import {render} from '@wordpress/element';
import {getPath} from './helpers/utils';
import UpsellRouter from "./pages";

const appRoot = document.querySelector('#wpbody-content .wrap');

if (appRoot) {
  render(
    <UpsellRouter />, 
    appRoot.appendChild(document.createElement('div'))
  );
}